import type { LinkResolverType, Prismic } from '@landsbankinn/prismic';
import { isEmptyText, PrismicText, Embed } from '@landsbankinn/prismic';
import { Segment } from '@landsbankinn/ui';
import React from 'react';
import { TextWithEmbed } from '../components/slices/TextWithEmbed';

interface IProps {
  copy: Prismic.RichText;
  video: Prismic.Embed;
  align: string;
  template: string;
  linkResolver: LinkResolverType;
}

export const TextWithVideoContainer = ({ copy, video, template }: IProps) => {
  if (isEmptyText(copy)) {
    return null;
  }

  const isArticle = template === 'article';

  return (
    <Segment isArticle={isArticle}>
      <TextWithEmbed
        embed={
          video && (
            <Embed
              html={(video as any)[0]?.oembed?.html}
              type="inline"
              noSpace
            />
          )
        }
        isArticle={isArticle}
      >
        <PrismicText value={copy} isArticle={isArticle} />
      </TextWithEmbed>
    </Segment>
  );
};
